const setDefaultProfileNestedNames = (profile) => {
  profile.units.forEach((unit, unitIndex) => {
    // Trim whitespace from unit.name if it exists
    if (unit.name) {
      unit.name = unit.name.trim()
    }
    // Set a new default unit name.
    // Check if the name is empty or matches the old pattern format
    if (!unit.name || unit.name === "" || /^Unit \d+$/.test(unit.name)) {
      unit.name = `${profile.name} > Unit ${unitIndex + 1}`
    }

    // Ensure model_types exists
    if (!unit.model_types) {
      unit.model_types = []
      return // Skip further processing if we just created the model_types array
    }

    unit.model_types.forEach((modelType, modelTypeIndex) => {
      // Trim whitespace from modelType.name if it exists
      if (modelType.name) {
        modelType.name = modelType.name.trim()
      }
      // Set a new default modelType name.
      // Check if the name is empty or matches the old pattern format
      if (
        !modelType.name ||
        modelType.name === "" ||
        /^.+: Model type \d+$/.test(modelType.name)
      ) {
        modelType.name = `${unit.name} > Model type ${modelTypeIndex + 1}`
      }
    })
  })
}

export default function migrateProfile(profile) {
  // Ensure units array exists
  if (!profile.units) {
    profile.units = []
  }

  // Ensure each unit has model_types
  profile.units.forEach((unit) => {
    if (!unit.model_types && !unit.modelTypes) {
      unit.model_types = []
    }
  })

  if (typeof profile.weaponsSelected !== "undefined") {
    if (typeof profile.weaponsSelected.melee !== "undefined") {
      profile.weapons_selected_melee = profile.weaponsSelected.melee
    }
    if (typeof profile.weaponsSelected.ranged !== "undefined") {
      profile.weapons_selected_ranged = profile.weaponsSelected.ranged
    }
    delete profile.weaponsSelected
  }

  if (typeof profile.orderSlain !== "undefined") {
    if (typeof profile.orderSlain.auto !== "undefined") {
      profile.order_slain_auto = profile.orderSlain.auto
    }
    if (typeof profile.orderSlain.order !== "undefined") {
      profile.order_slain_model_types = profile.orderSlain.order
    }
    delete profile.orderSlain
  }

  if (typeof profile.computed !== "undefined") {
    if (typeof profile.computed.keywords !== "undefined") {
      profile.computed_keywords = profile.computed.keywords
    }

    if (typeof profile.computed.leaders !== "undefined") {
      profile.computed_leaders = profile.computed.leaders
    }

    if (typeof profile.computed.modelCount !== "undefined") {
      profile.computed_model_count = profile.computed.modelCount
    }

    if (typeof profile.computed.points !== "undefined") {
      profile.computed_points = profile.computed.points
    }

    if (typeof profile.computed.roles !== "undefined") {
      profile.computed_roles = profile.computed.roles
    }

    if (typeof profile.computed.toughness !== "undefined") {
      profile.computed_toughness = profile.computed.toughness
    }

    if (typeof profile.computed.wounds !== "undefined") {
      profile.computed_wounds = profile.computed.wounds
    }

    delete profile.computed
  }

  // Migrate profile to use the same timestamp format (ISO 8601)
  // as supabase for created and updated properties.

  if (typeof profile.created !== "undefined") {
    const date = new Date(profile.created)
    profile.created = date.toISOString()
  }

  if (typeof profile.updated !== "undefined") {
    const date = new Date(profile.updated)
    profile.updated = date.toISOString()
  }

  profile.units.forEach((unit) => {
    if (typeof unit.modelTypes !== "undefined") {
      unit.model_types = unit.modelTypes
      delete unit.modelTypes
    } else if (!unit.model_types) {
      unit.model_types = []
    }
  })

  setDefaultProfileNestedNames(profile)

  profile.units.forEach((unit) => {
    // Initialise unit.abilities_selected if it doesn't exist
    if (!unit.abilities_selected) {
      unit.abilities_selected = []
    }
  })

  // Move profile.abilitiesSelected data from unit.abilities_selected
  if (profile.abilitiesSelected && profile.abilitiesSelected.length > 0) {
    profile.units.forEach((unit) => {
      // For each ability in profile.abilities_selected
      profile.abilitiesSelected.forEach((abilityId) => {
        // Check if the unit has this ability in its abilities array
        // The abilities stored in unit.abilities are objects that have ids
        if (
          unit.abilities &&
          unit.abilities.some((ability) => ability.id === abilityId)
        ) {
          // Add to unit.abilities_selected if not already there
          if (!unit.abilities_selected.includes(abilityId)) {
            unit.abilities_selected.push(abilityId)
          }
        }
      })
    })

    // Delete the profile-level abilitiesSelected since they've been moved to units
    delete profile.abilitiesSelected
  }

  return profile
}
